var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "my-modal",
      attrs: {
        id: "modal-comments",
        title: "Comentarios",
        "ok-title": "Vale",
        size: "lg",
        "ok-only": ""
      },
      on: { ok: _vm.handleOk }
    },
    [
      _c(
        "div",
        { staticClass: "container-comments" },
        [
          _c(
            "app-timeline",
            _vm._l(_vm.commentsWithComments, function(comment, index) {
              return _c(
                "app-timeline-item",
                {
                  key: index,
                  staticClass: "border-bottom",
                  attrs: { variant: "primary" }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0"
                    },
                    [
                      _c("h6", { staticClass: "mb-0" }, [
                        _vm._v(_vm._s(comment.comentario))
                      ]),
                      _c(
                        "div",
                        { staticClass: "mr-4" },
                        [
                          _c("small", { staticClass: "text-muted" }, [
                            _vm._v(
                              _vm._s(_vm._f("dateFormatTime")(comment.fecha))
                            )
                          ]),
                          _vm.canDeleteComment(comment)
                            ? _c("feather-icon", {
                                directives: [
                                  {
                                    name: "has-permission",
                                    rawName: "v-has-permission",
                                    value: "ED271",
                                    expression: "'ED271'"
                                  },
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: "Eliminar comentario",
                                    expression: "'Eliminar comentario'"
                                  }
                                ],
                                staticClass: "ml-2 text-danger cursor-pointer",
                                attrs: {
                                  "data-cy": "delete-comment",
                                  icon: "Trash2Icon"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.remover(comment)
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  ),
                  _c("p", { staticClass: "mb-2" }, [
                    _vm._v(" " + _vm._s(comment.nombre) + " ")
                  ]),
                  _c("div", {}, [
                    comment.documentos
                      ? _c(
                          "div",
                          { staticClass: "mb-1 mb-sm-0" },
                          _vm._l(comment.documentos, function(
                            attachment,
                            index
                          ) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "d-flex mb-1 color-primary"
                              },
                              [
                                _c("DownloadFile", {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip.bottom-end",
                                      value: "" + attachment.nombre,
                                      expression: "`${attachment.nombre}`",
                                      modifiers: { "bottom-end": true }
                                    }
                                  ],
                                  staticClass: "pill-info-attach mr-1",
                                  attrs: {
                                    mood: "compact",
                                    path: attachment.adjuntoUrl,
                                    name: attachment.nombre,
                                    "version-id": attachment.versionId
                                  }
                                }),
                                _vm._v(" " + _vm._s(attachment.nombre) + " "),
                                _vm.canDeleteComment(comment)
                                  ? _c("feather-icon", {
                                      directives: [
                                        {
                                          name: "has-permission",
                                          rawName: "v-has-permission",
                                          value: "ED272",
                                          expression: "'ED272'"
                                        },
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip",
                                          value: "Eliminar adjunto",
                                          expression: "'Eliminar adjunto'"
                                        }
                                      ],
                                      staticClass:
                                        "ml-2 text-danger cursor-pointer",
                                      attrs: {
                                        "data-cy": "delete-attachment",
                                        icon: "Trash2Icon"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.removerAdjunto(attachment)
                                        }
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          }),
                          0
                        )
                      : _vm._e()
                  ])
                ]
              )
            }),
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }